<template>
  <div class="modal-consent">
    <div class="modal-consent__header">
      <h2 class="modal-consent__title">{{ $root.staticText.cookies.title }}</h2>
    </div>
    <div class="modal-consent__items">
      <div class="modal-consent__item" v-for="item in items" :key="item.name">
        <Checkbox v-model="item.value" :id="item.name" :disabled="item.disabled" :error="item.error" is-white>
          <template #label>
            <span class="modal-consent__item-text">
              <span class="modal-consent__item-title">{{ item.title }}</span>
              <span class="modal-consent__item-description">{{ item.description }}</span>
            </span>
          </template>
        </Checkbox>
      </div>
    </div>
    <div class="modal-consent__actions">
      <button type="button" class="t-btn _green _big" @click="save">{{ $root.staticText.common.save }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Checkbox from '@shared/ui/public/forms/fields/Checkbox.vue'
import { MODAL_TYPE_RESULT } from '@shared/const/modal.const'

export default {
  name: 'consent',
  components: {
    Checkbox,
  },
  props: ['props'],
  data() {
    return {
      items: [
        {
          name: 'technical',
          value: true,
          disabled: true,
          title: this.$root.staticText.cookies.technical.title,
          description: this.$root.staticText.cookies.technical.text,
        },
        {
          name: 'analytics',
          value: true,
          disabled: true,
          title: this.$root.staticText.cookies.analytics.title,
          description: this.$root.staticText.cookies.analytics.text,
        },
        {
          name: 'marketing',
          value: true,
          disabled: false,
          title: this.$root.staticText.cookies.marketing.title,
          description: this.$root.staticText.cookies.marketing.text,
        },
      ],
    }
  },
  created() {
    if (this.props?.decided) this.initItems(this.props)
  },
  methods: {
    ...mapActions('modal', ['modalClose']),

    initItems(data) {
      this.items.forEach(item => {
        item.value = !!data[item.name]
      })
    },

    save() {
      const data = this.items.reduce(
        (acc, item) => {
          acc[item.name] = item.value
          return acc
        },
        { decided: true }
      )

      this.modalClose({
        type: this.props?.decided ? MODAL_TYPE_RESULT.consentChanged : MODAL_TYPE_RESULT.consentSave,
        data,
      })
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.modal-consent
  max-width: 800px
  font-family: Roboto, sans-serif
  color: #000000
  font-size: 18px

  @media (max-width: $mobile-size)
    font-size: 16px

  &__items
    display: flex
    flex-direction: column
    gap: 59px
    margin-top: 72px

    @media (max-width: $mobile-size)
      margin-top: 25px
      gap: 30px

  &__item
    &-title
      display: inline-block
      width: 100%
      font-weight: 700

  &__actions
    display: flex
    justify-content: center
    margin-top: 64px

    @media (max-width: $mobile-size)
      margin-top: 32px
</style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/consent.vue